/* eslint-disable jsx-a11y/anchor-is-valid */
// React
import React, { useEffect, useState } from "react"
import { Box, Typography, Chip } from "@mui/material"
import { useTranslation } from "react-i18next"
import { Link as ReactRouterLink, useNavigate } from "react-router-dom"
import { DataGrid, GridCellParams, GridColDef, enUS } from "@mui/x-data-grid"
import { thTHGrid } from "../../../@types/DataGridLocaleText"
import dayjs from "dayjs"
import fontkit from "@pdf-lib/fontkit"
import CircularProgress from "@mui/material/CircularProgress"
import Button from "@mui/material/Button"
import {
  getContractByUserId,
  updateContractById,
} from "../../../services/EmployeeContractService"
import {
  getDocumentsfile,
  getDocumentsfilePDF,
} from "../../../services/UserService"
// Services
// import { getAllActiveCompany } from "../../../services/MasterDataService" //เปลี่ยนมาใช้ useAppSelector
import { sendFilesDocuments } from "../../../services/UserService"
import { fetchProvinces } from "../../../../src/pages/users/AppFormPage/AddressInfo/fetchGeoData"

import { getPDPAByStatus, addPDPAUserData } from "../../../services/PDPAService"

// Hooks and Redux
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { fetchDocumentByUser } from "../../../redux/slices/documentsSlice"
import jwtDecode from "jwt-decode"
import { useForm } from "react-hook-form"
import Swal from "sweetalert2"
import { PDFDocument, PDFTextField, PDFName } from "pdf-lib"
// Types
import { TokenPayload } from "../../../@types"
import { CompanyInter } from "../../../@types/ECData.type"
import { validateMicrosoftFile } from "../../../utils"
import { numToThaiBaht } from "../../../utils/thaiBahtText"

// Styles,
import theme from "../../../styles/theme"

// Components
import ConfirmationDialogPDPA from "../../auth/sign_up/consentPDPA"

interface StatusFileUploadStatus {
  data: any[]
}

interface ContractFile {
  dataPath: string
  name: string
  type: string
}

interface ContractDocument {
  id: string
  job: {
    position: string
    company: string
    hireDate: string
  }
  is_active: boolean
  is_signed_active: boolean
  typeEC: string
  nameFile: string
  dmsFileId: string
  nameDoc: string
  file: ContractFile
  positionName?: string
}

interface EcData {
  amount_101: number | null
  amount_102: number | null
  amount_103_1: number | null
  amount_125: number | null
  amount_128: number | null
  amount_133: number | null
  amount_163: number | null
  app_form_status_id: string
  bank: string
  bank_account_number: string
  company: string
  contract_end_date: string | null
  contract_start_date: string | null
  country_of_birth: string
  country_of_national_id: string
  created_by: string
  created_date: string
  date_of_birth: string
  exported: boolean
  exported_date: string
  first_name_en: string
  first_name_th: string
  gender: string
  hire_date: string
  holiday_schedule: string
  id: string
  incentive_group: string
  is_active: boolean
  job_relationship_email: string
  last_name_en: string
  last_name_th: string
  legal_building: string | null
  legal_country: string
  legal_district: string
  legal_floor: string | null
  legal_house_number: string
  legal_lane: string
  legal_moo: string
  legal_postal_code: string
  legal_province: string
  legal_room_no: string | null
  legal_street: string
  legal_sub_district: string
  legal_village: string | null
  mailing_building: string | null
  mailing_country: string
  mailing_district: string
  mailing_floor: string | null
  mailing_house_number: string
  mailing_lane: string
  mailing_moo: string
  mailing_postal_code: string
  mailing_province: string
  mailing_room_no: string | null
  mailing_street: string
  mailing_sub_district: string
  mailing_village: string | null
  marital_status: string
  modified_by: string
  modified_date: string
  national_id: string
  national_id_card_type: string
  nationality: string
  pay_grade: string
  pay_group: string
  phone_number: string
  position: string
  prefix: string
  registered_sso: string | null
  religion: string
  same_as_legal: string
  site_id: string
  sso_hospital: string | null
  time_reporter_type: string
  utilized: string
  work_group: string
  work_schedule: string
}

interface DocumentActiveData {
  EmploymentContract: {
    id: string
    nameFile: string
    name: string
    type: string
    dmsFileId: string
    emplist?: any
  }
  empSigned?: string
  emplist?: any
  contractId: string
  created_by: string
  created_date: string
  dmsFileId: string
  ecData: EcData
  ecId: string
  id: string
  is_active: boolean
  is_signed_active: boolean
  modified_by: string | null
  modified_date: string | null
  nameFile: string
  positionName: string
  typeEC: string
  userId: string
}

interface FieldValues {
  [key: string]: string
}

interface iPDPAUser {
  pdpaVersionId: string
  userId: string
  actionType: string
  created_by: string
}

enum PDPAActionType {
  CreateProfile = "CreateProfile",
  ApplyJob = "ApplyJob",
  SignContact = "SignContact",
}

interface IPDPAData {
  id: string
  pdpaName: string
  version: string
  thaiContent: string
  englishContent: string
  activeDate: string
  expirationDate: string
  is_active: boolean
  created_by: string
  created_date: string
  modified_by: string | null
  modified_date: string
}

const FileContract: React.FunctionComponent<StatusFileUploadStatus> = ({
  data,
}) => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { register } = useForm()
  const token = localStorage.getItem("access_token") || ""
  const decoded: TokenPayload = jwtDecode(token)
  const userId = decoded?.UserId || ""
  const parsedToken: TokenPayload = jwtDecode(localStorage.access_token)

  const [contracts, setContracts] = useState<ContractDocument[]>([])
  const [isLoadingContractList, setIsLoadingContractList] =
    useState<boolean>(true)
  const [pdfRows, setPdfRows] = useState<string | null>(null)
  const [pdfBytes, setPdfBytes] = useState<Uint8Array | null>(null)
  const [isLoadingCompanyList, setIsLoadingCompanyList] =
    useState<boolean>(false) // เปลี่ยนมาใช้ useAppSelector (ข้อมูลพร้อมใช้จาก store แล้ว)
  const [activeContractDocument, setActiveContractDocument] =
    useState<DocumentActiveData | null>(null)
  // เปลี่ยนมาใช้ useAppSelector
  // const [companyList, setCompanyList] = useState<CompanyInter[]>([])
  const { companies: companyList } = useAppSelector((state) => state.masterData)
  const [arrayBlob, setArrayBlob] = useState<any>()
  const [provinceJSON, setProvinceJSON] = useState<any[]>([])
  const [openPDPA, setOpenPDPA] = useState<boolean>(false)
  const [pdpaStatus, setPdpaStatus] = useState<boolean>(false)
  const [pdpaData, setPdpaData] = useState<IPDPAData | null>(null)
  const [pdpaConfirm, setPdpaConfirm] = useState<boolean>(false)

  useEffect(() => {
    const fetchPDPAStatus = async () => {
      try {
        const pdpaStatus = await getPDPAByStatus("active")
        if (pdpaStatus?.data?.pdpas?.count > 0) {
          setPdpaStatus(true)
          setPdpaData(pdpaStatus?.data?.pdpas?.data)
          // Swal.fire({
          //   icon: "error",
          //   title: `${t("Error")}`,
          //   text: `${t("ขออภัย ระบบกำลังปรับปรุง กลับมาใช้อีกครั้ง")}`,
          // }).then((result) => {
          //   if (result.isConfirmed) {
          //     window.location.href = "/"
          //   }
          // })
          // } else {
          //   // setOpenPDPA(true)
        }
      } catch (error) {
        navigate("/servererror", { replace: true })
      }
    }

    fetchPDPAStatus()
  }, [navigate])

  const handlepdpaConsentDialog = () => {
    setOpenPDPA(false)
    setPdpaConfirm(true)

    if (
      activeContractDocument &&
      activeContractDocument?.ecData &&
      activeContractDocument?.dmsFileId &&
      pdpaData
    ) {
      const dataToField = activeContractDocument.ecData

      Swal.fire({
        icon: "warning",
        title: "กรุณาตรวจสอบข้อมูลในสัญญาจ้าง",
        text: "ยืนยันการการเซ็นสัญญา",
        confirmButtonText: `${t("ok")}`,
        cancelButtonText: `ยกเลิก`,
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const resPDPA = {
            pdpaVersionId: pdpaData.id,
            userId: userId,
            actionType: PDPAActionType.SignContact,
            created_by: parsedToken.Username,
          }

          await addPDPAUserData(resPDPA)

          const checkSetPDF = await setInfroPDF(
            activeContractDocument,
            true,
            true,
            dataToField
          )
          if (checkSetPDF) {
            Swal.fire({
              icon: "success",
              title: `${t("Success")}`,
              text: "เซ็นสัญญาสำเร็จ", //`${t("Ecsuccess")}`,
              confirmButtonText: `${t("ok")}`,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload()
              }
            })
          } else {
            Swal.fire({
              icon: "error",
              title: `${t("Error")}`,
              text: `${t("Please try again")}`,
              confirmButtonText: `${t("ok")}`,
            })
          }
        }
      })
    } else {
      Swal.fire({
        icon: "error",
        title: `${t("Error")}`,
        text: `${t("Please try again")}`,
        confirmButtonText: `${t("ok")}`,
      })
    }
  }

  const { document: reduxDocuments } = useAppSelector(
    (state) => state.documentDMS
  )
  const dispatch = useAppDispatch()

  const columns: GridColDef[] = [
    {
      field: "is_signed_active",
      headerName: `${t("text_signed_status")}`,
      width: 150,
      valueGetter: (params: GridCellParams) => params.row.is_signed_active,
      renderCell: (params: GridCellParams) => {
        const status_applicant = params.row.is_signed_active
          ? t("text_signed_active")
          : t("text_signed_inactive")
        const statusColor = params.row.is_signed_active ? "#49AF4D" : "#ff4f40"
        return (
          <Chip
            variant="outlined"
            sx={{
              bgcolor: statusColor,
              borderColor: statusColor,
              fontWeight: "normal",
              color: "white",
              my: 2,
            }}
            size="medium"
            label={status_applicant}
          />
        )
      },
    },
    {
      field: "dmsFileId",
      headerName: `${t("text_file_dms")}`,
      width: 300,
      valueGetter: (params: GridCellParams) => params.row?.dmsFileId,
      renderCell: (params: GridCellParams) => {
        const fileId = params.row.dmsFileId
        const dataPath = params.row?.file?.dataPath
        const fileName = params.row?.file?.name || params.row?.name
        const isMicrosoftFile = validateMicrosoftFile(fileName)

        if (fileId && dataPath) {
          if (isMicrosoftFile) {
            return (
              <a href={dataPath} download={fileName}>
                {fileName}
              </a>
            )
          } else {
            return (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a
                onClick={() => debugBase64New(dataPath)}
                style={{ cursor: "pointer" }}
              >
                {fileName}
              </a>
            )
          }
        }
        return fileId || "-"
      },
    },
    {
      field: "signcontact",
      headerName: `${t("text_file_btn_sign")}`,
      width: 200,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            disabled={params.row.is_signed_active}
            sx={{
              backgroundColor: theme.palette.button.main,
              color: "white",
              "&:hover": {
                backgroundColor: "#0288d1",
              },
              minWidth: "fit-content",
              minHeight: "42px",
            }}
            onClick={handleBtnSignedContract}
          >
            {t("text_file_btn_sign")}
          </Button>
        )
      },
    },
    {
      field: "download",
      headerName: `${t("Download")}`,
      width: 160,
      renderCell: (params: GridCellParams) => {
        const dataPath = params.row?.file?.dataPath
        const fileName =
          params.row?.file?.name || params.row?.nameFile || "contract"
        const isMicrosoftFile = validateMicrosoftFile(fileName)

        if (!dataPath) return null

        if (isMicrosoftFile) {
          return (
            <Button
              variant="outlined"
              component="a"
              href={dataPath}
              download={fileName}
              sx={{
                minWidth: "fit-content",
                minHeight: "42px",
              }}
            >
              {t("Download")}
            </Button>
          )
        }

        return (
          <Button
            variant="outlined"
            sx={{
              minWidth: "fit-content",
              minHeight: "42px",
            }}
            onClick={() => downloadPDF(dataPath, fileName)}
          >
            {t("Download")}
          </Button>
        )
      },
    },
    {
      field: "document_hire_date",
      headerName: `${t("Hire Date")}`,
      width: 150,
      renderCell: (params: GridCellParams) => {
        const [day, month, year] = params.row.job?.hireDate
          .split("/")
          .map(Number)
        return (
          <Typography sx={{ fontSize: 14 }}>{`${day}/${month}/${
            year + 543
          }`}</Typography>
        )
      },
    },
    {
      field: "positionName",
      headerName: `${t("Position")}`,
      width: 150,
      renderCell: (params: GridCellParams) => {
        const positionName = params.row.positionName
        return <Typography sx={{ fontSize: 14 }}>{positionName}</Typography>
      },
    },
    {
      field: "company",
      headerName: `${t("Company")}`,
      width: 200,
      renderCell: (params: GridCellParams) => {
        const company = mapNameCompany(params?.row?.job?.company)
        return <Typography sx={{ fontSize: 14 }}>{company}</Typography>
      },
    },
    {
      field: "document_creation_date",
      headerName: `${t("text_document_creation_date")}`,
      width: 150,
      renderCell: (params: GridCellParams) => {
        const created_date = dayjs(params.row.created_date).format(
          "DD/MM/BBBB HH:mm"
        )
        return <Typography sx={{ fontSize: 14 }}>{created_date}</Typography>
      },
    },
    {
      field: "modified_date",
      headerName: `${t("Last Modified Date")}`,
      width: 150,
      renderCell: (params: GridCellParams) => {
        if (params.row.modified_date) {
          const modified_date =
            dayjs(params.row.modified_date).format("DD/MM/BBBB HH:mm") ?? "-"
          return <Typography sx={{ fontSize: 14 }}>{modified_date}</Typography>
        } else {
          return <Typography sx={{ fontSize: 14 }}>-</Typography>
        }
      },
    },
  ]

  useEffect(() => {
    const fetchProvincesData = async () => {
      try {
        const provincesData = await fetchProvinces()
        setProvinceJSON(provincesData)
      } catch (error) {
        navigate("/servererror", { replace: true })
      }
    }

    fetchProvincesData()
  }, [navigate])

  const debugBase64 = (base64URL: string) => {
    const win = window.open()
    if (win) {
      win.document.write(
        `<iframe src="${base64URL}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`
      )
    }
  }

  const debugBase64New = (base64URL: string) => {
    try {
      const base64Data = base64URL.split(",")[1]
      const byteCharacters = atob(base64Data)
      const byteArray = new Uint8Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i)
      }
      const blob = new Blob([byteArray], { type: "application/pdf" })
      const objectUrl = URL.createObjectURL(blob)
      window.open(objectUrl, "_blank")
    } catch (error) {
      console.error("Error opening PDF:", error)
    }
  }

  const downloadPDF = (base64URL: string, fileName: string) => {
    try {
      const base64Data = base64URL.split(",")[1]
      const byteCharacters = atob(base64Data)
      const byteArray = new Uint8Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i)
      }
      const blob = new Blob([byteArray], { type: "application/pdf" })
      const objectUrl = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = objectUrl
      link.download = fileName.endsWith(".pdf") ? fileName : `${fileName}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(objectUrl)
    } catch (error) {
      console.error("Error downloading PDF:", error)
    }
  }

  // const calculateAge = async (dateOfBirth: string) => {
  //   const birthY = dateOfBirth.toLocaleString().split("/")[2]
  //   const birthM = dateOfBirth.toLocaleString().split("/")[1]
  //   const birthD = dateOfBirth.toLocaleString().split("/")[0]

  //   const now = new Date()
  //   now.setHours(0, 0, 0, 0)
  //   let age = now.getFullYear() - Number(birthY)

  //   const m = now.getMonth() - Number(birthM)
  //   if (m < 0 || (m === 0 && now.getDate() < Number(birthD))) {
  //     age--
  //   }

  //   return age.toString()
  // }
  // NOTE: calculateAge — ซ้ำกับ admin/PersonalInfo.tsx, EditJobDetailData.tsx, SignUp.tsx, JobAppDetail.tsx, ExcelEcDetail.tsx, UploadExcel.tsx ควรย้ายไปรวมใน utils/index.ts
  const calculateAge = async (dateOfBirth: Date) => {
    const birthY = dateOfBirth.toLocaleString().split("/")[2]
    const birthM = dateOfBirth.toLocaleString().split("/")[1]
    const birthD = dateOfBirth.toLocaleString().split("/")[0]
    const now = new Date()
    now.setHours(0, 0, 0, 0)

    let age = now.getFullYear() - parseInt(birthY)
    const monthDiff = now.getMonth() + 1 - parseInt(birthM)
    const dateDiff = now.getDate() - parseInt(birthD)

    let monthCalcul = monthDiff

    if (monthDiff < 0 || (monthDiff === 0 && dateDiff < 0)) {
      age--
    }

    if (isNaN(age)) {
      return "-"
    }

    if (monthDiff < 0) {
      monthCalcul = 12 + monthDiff
    }

    return age.toString()
  }

  const hireDate = async (date: string) => {
    const [day, month, year] = date.split("/").map(Number)

    return `${day}/${month}/${year + 543}`
  }

  const arrayBufferToBase64DataUrl = async (
    arrayBuffer: ArrayBuffer,
    mimeType: string
  ) => {
    return new Promise((resolve, reject) => {
      const blob = new Blob([arrayBuffer], { type: mimeType })
      const reader = new FileReader()

      reader.onload = function (event) {
        resolve(event?.target?.result)
      }

      reader.onerror = function (error) {
        reject(error)
      }
      reader.readAsDataURL(blob)
    })
  }

  const setPdfTextFields = (
    form: any,
    fieldValues: FieldValues,
    customFont: any
  ) => {
    const fields = form.getFields()
    for (const field of fields) {
      const getName = field.getName()
      for (const fieldName in fieldValues) {
        try {
          if (fieldName === getName) {
            const value = fieldValues[fieldName]
            field.setText(value)
            field.setFontSize(13)
            field.updateAppearances(customFont)
          }
        } catch (error) {
          console.log(`Error setting field "${fieldName}":`, error)
        }
      }
    }
  }

  const mapNameCompany = (companyCode: string): string => {
    const company = companyList.find(
      (item: CompanyInter) => companyCode === item.company_code
    )
    return company ? `${company.company_name}` : companyCode
  }

  // เปลี่ยนมาใช้ useAppSelector
  // useEffect(() => {
  //   const fetchAllActiveCompany = async () => {
  //     try {
  //       const response = await getAllActiveCompany(true)
  //       if (response.data?.success) {
  //         setCompanyList(response?.data?.companies)
  //       }
  //     } catch (error) {
  //       console.error("Error fetching active companies:", error)
  //     } finally {
  //       setIsLoadingCompanyList(false)
  //     }
  //   }

  //   fetchAllActiveCompany()
  // }, [])

  useEffect(() => {
    const fetchContractData = async () => {
      setIsLoadingContractList(true)
      try {
        const response = await getContractByUserId(userId)
        if (response?.data?.success && response?.data?.data?.length > 0) {
          const fetchedContracts = response?.data?.data as DocumentActiveData[]
          const activeContract = fetchedContracts.find(
            (item: DocumentActiveData) => item.is_active === true
          )

          setActiveContractDocument(activeContract || null)

          if (!activeContract) {
            console.warn("No active contract found.")
            setContracts([])
            return
          }

          if (!activeContract.is_signed_active) {
            if (activeContract.ecData && activeContract.dmsFileId) {
              const dataToField = activeContract.ecData
              await setInfroPDF(activeContract, false, false, dataToField)
            }
          } else {
            const base64Data = await getDocumentsfile(
              activeContract.dmsFileId,
              "contractSigned"
            )

            if (activeContract) {
              const processedContracts: ContractDocument[] = [
                {
                  id: activeContract.id,
                  job: {
                    position: activeContract.ecData.position || "",
                    company: activeContract.ecData.company || "",
                    hireDate: activeContract.ecData.hire_date || "",
                  },
                  positionName: activeContract.positionName || "",
                  is_active: activeContract.is_active,
                  is_signed_active: activeContract.is_signed_active,
                  typeEC: activeContract.typeEC,
                  nameFile: activeContract.nameFile,
                  dmsFileId: activeContract.dmsFileId,
                  nameDoc:
                    activeContract.EmploymentContract.name ||
                    "Contract Document",
                  file: {
                    dataPath:
                      base64Data.status === 200
                        ? (base64Data.data as string)
                        : "",
                    name: activeContract.nameFile || "Contract Document",
                    type:
                      activeContract.EmploymentContract.type ||
                      "application/pdf",
                  },
                },
              ]

              setContracts(processedContracts)
            }
          }
        } else {
          setContracts([])
        }
      } catch (error) {
        console.error("Error fetching contract by user ID:", error)
        setContracts([])
      } finally {
        setIsLoadingContractList(false)
      }
    }

    if (!isLoadingCompanyList) {
      fetchContractData()
    }
  }, [userId, isLoadingCompanyList, navigate, companyList])

  const findFieldPageNumber = async (
    arrayBuffer: string | ArrayBuffer,
    fieldName: string
  ): Promise<number> => {
    try {
      const pdfDoc = await PDFDocument.load(arrayBuffer)
      const form = pdfDoc.getForm()
      const fields = form.getFields()
      const pages = pdfDoc.getPages()

      let foundOnPage = 0
      const P = PDFName.of("P")
      for (const field of fields) {
        const name = field.getName()
        if (name.toLocaleLowerCase().includes(fieldName.toLocaleLowerCase())) {
          const widgets = field.acroField.getWidgets()
          for (const widget of widgets) {
            const widgetDict = widget.dict
            const pageRef = widgetDict.get ? widgetDict.get(P) : null
            foundOnPage = pageRef
              ? pages.findIndex((page) => page?.ref === pageRef)
              : 0
          }
        }
      }

      return foundOnPage
    } catch (error) {
      console.error(`Error processing PDF ${arrayBuffer}:`, error)
      throw error
    }
  }

  const setInfroPDF = async (
    contract: DocumentActiveData,
    signStatus: boolean,
    signed: boolean,
    dataToField: any
  ) => {
    try {
      let convertedPdfDataUrl: any
      const alfrescoResponse = await getDocumentsfilePDF(contract.dmsFileId)
      let arrayBuffer: string | ArrayBuffer

      if (alfrescoResponse.status === 200 && alfrescoResponse.data?.data) {
        const base64PdfString = alfrescoResponse.data.data as string
        setPdfRows(base64PdfString)
        const bytes = Uint8Array.from(atob(base64PdfString), (c) =>
          c.charCodeAt(0)
        )
        setPdfBytes(bytes)
        arrayBuffer = bytes.buffer

        const pdfDoc = await PDFDocument.load(arrayBuffer)
        pdfDoc.registerFontkit(fontkit)
        const form = pdfDoc.getForm()
        const pages = pdfDoc.getPages()
        const fontBytes = await fetch(
          "../../../assets/fonts/TH_Sarabun.ttf"
        ).then((res) => res.arrayBuffer())
        const thaiFont = await pdfDoc.embedFont(fontBytes)
        const fields = form.getFields()
        const initialValues: { [key: string]: any } = {}
        const extractedFieldNames: string[] = []

        for (const field of fields) {
          const fieldName = field.getName()
          extractedFieldNames.push(fieldName)

          if (field instanceof PDFTextField) {
            initialValues[fieldName] = field.getText()
          }

          if (
            fieldName.indexOf("hr_signed_image_") === 0 ||
            fieldName.indexOf("hr_signed_image") === 0
          ) {
            const pageSigned = await findFieldPageNumber(arrayBuffer, fieldName)
            const targetField = form.getTextField(fieldName)
            if (targetField) {
              const widgets = targetField.acroField.getWidgets()
              if (widgets.length > 0) {
                const firstWidget = widgets[0]
                const { x, y, width, height } = firstWidget.getRectangle()

                if (contract && contract?.empSigned) {
                  const base64Data = await getDocumentsfile(
                    contract?.emplist?.dmsFileId,
                    "documentsEmp"
                  )

                  if (base64Data.status === 200) {
                    const base64Image = base64Data?.data.split(",")[1]
                    let signatureImage: any
                    if (contract?.emplist?.nameFile?.split(".")[1] === "png") {
                      signatureImage = await pdfDoc.embedPng(base64Image)
                    } else {
                      signatureImage = await pdfDoc.embedJpg(base64Image)
                    }

                    const firstPage = pages[pageSigned]
                    const imageDims = signatureImage.scaleToFit(width, height)
                    const xPos = x + (width - imageDims.width) / 2
                    const yPos = y + (height - imageDims.height) / 2

                    firstPage.drawImage(signatureImage, {
                      x: xPos,
                      y: yPos,
                      width: imageDims.width,
                      height: imageDims.height,
                    })

                    if (targetField) {
                      targetField.setText("")
                    }
                  }
                }
              }
            }
          }
        }

        const dataSet = await handleFieldsToSet(
          fields,
          dataToField,
          contract,
          signStatus
        )

        setPdfTextFields(form, dataSet, thaiFont)

        const modifiedPdfBytes = await pdfDoc.save()
        const modifiedArrayBuffer = modifiedPdfBytes.buffer as ArrayBuffer
        convertedPdfDataUrl = await arrayBufferToBase64DataUrl(
          modifiedArrayBuffer,
          "application/pdf"
        )
        setArrayBlob(convertedPdfDataUrl)
      }

      if (convertedPdfDataUrl) {
        const processedContracts: ContractDocument[] = [
          {
            id: contract.id,
            job: {
              position: contract.ecData.position || "",
              company: contract.ecData.company || "",
              hireDate: contract.ecData.hire_date || "",
            },
            positionName: contract.positionName || "",
            is_active: contract.is_active,
            is_signed_active: signed,
            typeEC: contract.typeEC,
            nameFile: contract.nameFile,
            dmsFileId: contract.dmsFileId,
            nameDoc: contract.EmploymentContract.name || "Contract Document",
            file: {
              dataPath: convertedPdfDataUrl as string,
              name: contract.nameFile || "Contract Document",
              type: contract.EmploymentContract.type || "application/pdf",
            },
          },
        ]
        setContracts(processedContracts)

        if (signed === true && convertedPdfDataUrl) {
          const uploadId = await uploadBase64AsString(
            convertedPdfDataUrl,
            contract.nameFile + ".pdf"
          )
          updateContractById({
            id: contract.id,
            is_signed_active: signed,
            dmsFileId: uploadId[0],
          })
        }

        return true
      } else {
        console.warn("Failed to generate modified PDF data URL.")
        setContracts([])
        return false
      }
    } catch (error) {
      console.error("Error processing PDF:", error)
      setContracts([])
      return false
    }
  }

  const handleFieldsToSet = async (
    fields: any,
    dataToField: any,
    activeContractDoc: any,
    signStatus: boolean
  ) => {
    const fieldsToSet: { [key: string]: any } = {}

    const hr = activeContractDoc?.emplist
      ? `${activeContractDoc?.emplist?.first_name_th} ${activeContractDoc?.emplist?.last_name_th}`
      : ""

    const employeeFullName =
      `${dataToField?.first_name_th} ${dataToField?.last_name_th}` || ""
    const employeeENFullName =
      `${dataToField?.first_name_en} ${dataToField?.last_name_en}` || ""

    if (!fields || !dataToField) {
      return fieldsToSet
    }

    for (const field of fields) {
      const fieldName = field.getName()
      const provinceData = provinceJSON
      const legalProvince = provinceData?.find(
        (province: any) =>
          province?.external_code === parseInt(dataToField?.legal_province)
      )
      if (
        fieldName.indexOf("company") === 0 ||
        fieldName.indexOf("company_") === 0
      ) {
        const mapComp = mapNameCompany(dataToField?.company)
        fieldsToSet[fieldName] = `${mapComp}` || ""
      } else if (
        fieldName.indexOf("contact_date") === 0 ||
        fieldName.indexOf("contact_date_") === 0
      ) {
        fieldsToSet[fieldName] = (await hireDate(dataToField?.hire_date)) || ""
      } else if (
        (fieldName.indexOf("employee_old") === 0 ||
          fieldName.indexOf("employee_old_") === 0) &&
        dataToField?.date_of_birth
      ) {
        const old = await calculateAge(dataToField?.date_of_birth)
        fieldsToSet[fieldName] = old || ""
      } else if (
        fieldName.indexOf("employee_phone") === 0 ||
        fieldName.indexOf("employee_phone_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.phone_number || ""
      } else if (
        fieldName.indexOf("employee_name_") === 0 ||
        fieldName.indexOf("employee_name_") === 0
      ) {
        fieldsToSet[fieldName] = employeeFullName || ""
      } else if (fieldName.indexOf("employee_en_name_") === 0) {
        fieldsToSet[fieldName] = employeeENFullName || ""
      } else if (
        hr &&
        (fieldName.indexOf("hr_name_") >= 0 ||
          fieldName.indexOf("hr_name") >= 0)
      ) {
        fieldsToSet[fieldName] = hr || ""
      } else if (
        fieldName.indexOf("nationID") === 0 ||
        fieldName.indexOf("nationID_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.national_id || ""
      } else if (
        fieldName.indexOf("hire_date") === 0 ||
        fieldName.indexOf("hire_date_") === 0
      ) {
        fieldsToSet[fieldName] = (await hireDate(dataToField?.hire_date)) || ""
      }
      // work
      else if (
        fieldName.indexOf("employee_position") === 0 ||
        fieldName.indexOf("employee_positione_") === 0
      ) {
        fieldsToSet[fieldName] = activeContractDoc?.positionName
          ? activeContractDoc?.positionName
          : activeContractDoc?.ecData?.positionName
          ? activeContractDoc?.ecData?.positionName
          : ""
      }
      // house
      else if (
        fieldName.indexOf("employee_house_number") === 0 ||
        fieldName.indexOf("employee_house_number_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_house_number || ""
      } else if (
        fieldName.indexOf("employee_soi") === 0 ||
        fieldName.indexOf("employee_soi_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_lane || ""
      } else if (
        fieldName.indexOf("employee_road") === 0 ||
        fieldName.indexOf("employee_road_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_street || ""
      } else if (
        fieldName.indexOf("employee_moo") === 0 ||
        fieldName.indexOf("employee_moo_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_moo || ""
      } else if (
        fieldName.indexOf("employee_sub_district") === 0 ||
        fieldName.indexOf("employee_sub_district_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_sub_district || ""
      } else if (
        fieldName.indexOf("employee_district") === 0 ||
        fieldName.indexOf("employee_district_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_district || ""
      } else if (
        fieldName.indexOf("employee_province") === 0 ||
        fieldName.indexOf("employee_province_") === 0
      ) {
        fieldsToSet[fieldName] = legalProvince?.label_th
          ? legalProvince?.label_th
          : dataToField?.legal_province || ""
      } else if (
        fieldName.indexOf("employee_postal_code") === 0 ||
        fieldName.indexOf("employee_postal_code_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_postal_code || ""
      } else if (
        fieldName.indexOf("employee_build") === 0 ||
        fieldName.indexOf("employee_build_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_building || ""
      } else if (
        fieldName.indexOf("employee_floor") === 0 ||
        fieldName.indexOf("employee_floor_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_floor || ""
      } else if (
        fieldName.indexOf("employee_room") === 0 ||
        fieldName.indexOf("employee_room_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_room || ""
      }
      //salary
      else if (
        fieldName.indexOf("employee_101") === 0 ||
        fieldName.indexOf("employee_101_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.amount_101?.toString() || ""
      } else if (
        fieldName.indexOf("employee_102") === 0 ||
        fieldName.indexOf("employee_102_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.amount_102?.toString() || ""
      } else if (
        fieldName.indexOf("employee_thaitext") === 0 ||
        fieldName.indexOf("employee_thaitext_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.amount_101
          ? numToThaiBaht(dataToField?.amount_101)
          : dataToField?.amount_102
          ? numToThaiBaht(dataToField?.amount_102)
          : ""
      } else if (signStatus) {
        const sign_date = dayjs(new Date()).format("DD/MM/BBBB")
        if (
          fieldName.indexOf("signed_date_") === 0 ||
          fieldName.indexOf("signed_date") === 0
        ) {
          fieldsToSet[fieldName] =
            `Digitally signed by: ${dataToField?.first_name_th} ${dataToField?.last_name_th} ${sign_date}` ||
            ""
        }
      } else {
        fieldsToSet[fieldName] = ""
      }
    }
    return fieldsToSet
  }

  const handleBtnSignedContract = async () => {
    if (pdpaStatus) {
      setOpenPDPA(true)
    } else {
      Swal.fire({
        icon: "error",
        title: `${t("Error")}`,
        text: `${t("ขออภัย ระบบกำลังปรับปรุง กลับมาใช้อีกครั้ง")}`,
      })
    }
  }

  useEffect(() => {
    dispatch(fetchDocumentByUser())
  }, [dispatch])

  const uploadBase64AsString = async (base64Str: any, fileName: string) => {
    try {
      const formData = new FormData()
      formData.append("uploadType", "employer")
      formData.append("businessPlace", "Betagro")
      formData.append("company", "Betagro")
      formData.append("filename", fileName)
      formData.append("createBy", userId)
      const blob = new Blob([base64Str], {
        type: "application/pdf",
      })
      formData.append("contract", blob, fileName)

      const resFilesDoc = await sendFilesDocuments(formData, userId)

      return resFilesDoc?.data
    } catch (error) {
      return []
    }
  }

  return (
    <div>
      {isLoadingContractList || isLoadingCompanyList ? (
        <Box display="flex" justifyContent="center" gap={2}>
          <CircularProgress color="success" size={20} />
          <Typography align="center">{t("Loading")}...</Typography>
        </Box>
      ) : contracts.length === 0 ? (
        <Typography align="center">{t("No data")}</Typography>
      ) : (
        <div>
          <Typography sx={{ mt: { xs: 3, sm: 6 }, mb: 3 }}>
            {t("text_contract_file_name")} f
          </Typography>
          <div role="tabpanel">
            {contracts.length > 0 ? (
              <DataGrid
                getRowId={(row) => row.id}
                getRowHeight={() => "auto"}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 10 },
                  },
                }}
                pageSizeOptions={[10, 20, 30, 40, 50]}
                rows={contracts}
                columns={columns}
                disableColumnMenu
                disableRowSelectionOnClick
                sx={{
                  "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus":
                    {
                      outline: "none !important",
                    },
                  fontSize: 15,
                }}
                localeText={
                  i18n.language === "en"
                    ? enUS.components.MuiDataGrid.defaultProps.localeText
                    : thTHGrid
                }
              />
            ) : (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                marginY={7}
                gap={2}
              >
                <Typography
                  align="center"
                  sx={{
                    fontSize: { xs: "14px", sm: "16px" },
                    letterSpacing: 0.5,
                  }}
                >
                  {t("No completed job positions found")}
                </Typography>
              </Box>
            )}
          </div>
        </div>
      )}
      <>
        <Box sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
          <ConfirmationDialogPDPA
            id="pdpa-consent"
            keepMounted
            open={openPDPA}
            onClose={handlepdpaConsentDialog}
            onCancel={() => {
              setOpenPDPA(false)
            }}
          />
        </Box>
      </>
    </div>
  )
}

export default FileContract
